import { getStationMetaData, getStationHostname } from '../../partners/fl/javascripts/distance-transmitter'

// Get default city location based on the station defined in the URL parameters
function getInitialLocation() {
  const urlParams = new URLSearchParams(window.location.search)
  const hasUrlParam = urlParams.has('station')
  let urlParamName = urlParams.get('station')
  
  let defaultLocation, defaultLat, defaultLon
  
  if (!hasUrlParam || !urlParamName) {
    defaultLocation = getStationHostname().city
    defaultLat = getStationHostname().lat
    defaultLon = getStationHostname().lon
  } else {
    urlParamName = urlParams.get('station').toUpperCase()
    defaultLocation = getStationMetaData(urlParamName).city
    defaultLat = getStationMetaData(urlParamName).lat
    defaultLon = getStationMetaData(urlParamName).lon
  }

  return {
    defaultLocation, defaultLat, defaultLon
  }
}

export { getInitialLocation }